import api from "@/services/api"
import { queryClient } from "@/queryClient"
import type { CreateEditProductRequest } from "../sharedTypes/products"
import { BASE_PRODUCTS_QUERY_KEY } from "@/services/queryKeys"

export const createProduct = async (
  params: CreateEditProductRequest
) => {
  await api.post("/products/products/", {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCTS_QUERY_KEY],
  })
}
